import styles from "./FloatButton.module.css";
import arrow from "../assets/arrow.png";

type Props = {
  onPress: () => void;
};

export const FloatButton = (props: Props) => {
  return (
    <div className={styles.container} onClick={props.onPress}>
      <div className={styles.arrow} />
      <div className={styles.label}>Go to Trems of Use</div>
    </div>
  );
};
